import {RoomBaseApiService} from "@/core/service/room.baseapi.service";
import {ErrorWrapper, ResponseWrapper} from "@/core/service/util";

export class GroupService extends RoomBaseApiService {
    async getGroup(groupId) {
        try {
            const response = await this.request().get(`/api/v3/group/${groupId}`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
    async getGroupByRoom(roomId) {
        try {
            const response = await this.request().get(`/api/v3/group/room/${roomId || this.getRoomId()}`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
    async getGroupUX(groupId) {
        try {
            const response = await this.request().get(`/api/v3/group/${groupId}/groupUX`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const groupService = new GroupService()